import React from 'react';
import { WebsiteDesignProps } from './types';
import { Scale, Gavel, Book } from 'lucide-react';
import { Button } from "@/components/ui/button";

const LegalEagle: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Lex Justitia Academy";

    return (
        <div className="bg-[#f2f4f6] min-h-screen font-serif text-[#1e293b]">
            <div className="bg-[#0f172a] text-white py-2 px-8 text-xs font-sans tracking-wider uppercase text-center md:text-right">
                Excellence in Legal Education Since 1985
            </div>

            <nav className="bg-white border-b border-gray-200 py-6 px-8 sticky top-0 z-50 shadow-sm">
                <div className="container mx-auto flex justify-between items-center">
                    <div className="flex items-center gap-3">
                        <Scale size={32} className="text-[#0f172a]" />
                        <span className="text-2xl font-bold tracking-tight text-[#0f172a]">{schoolName}</span>
                    </div>
                    <div className="hidden md:flex gap-8 font-sans font-medium text-gray-600">
                        <a href="#" className="hover:text-[#0f172a]">Admissions</a>
                        <a href="#" className="hover:text-[#0f172a]">Faculty</a>
                        <a href="#" className="hover:text-[#0f172a]">Clinics</a>
                        <a href="#" className="hover:text-[#0f172a]">Alumni</a>
                    </div>
                    <Button className="bg-[#0f172a] hover:bg-[#1e293b] text-white font-sans font-bold">
                        Applicant Portal
                    </Button>
                </div>
            </nav>

            <header className="relative bg-[#0f172a] text-white py-24">
                <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/p6.png')]"></div>
                <div className="container mx-auto px-8 relative z-10 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                    <div>
                        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
                            Defending the Rule <br/> of Law.
                        </h1>
                        <p className="text-lg text-slate-300 mb-8 max-w-lg leading-relaxed font-sans">
                            We prepare the next generation of attorneys, judges, and policymakers to uphold justice with integrity and skill.
                        </p>
                        <div className="flex gap-4">
                            <Button className="bg-white text-[#0f172a] hover:bg-gray-100 font-sans font-bold h-12 px-8">
                                View Curriculum
                            </Button>
                        </div>
                    </div>
                    <div className="flex justify-center md:justify-end">
                        <div className="w-64 h-64 bg-[#1e293b] rounded-full flex items-center justify-center border-4 border-[#334155] shadow-2xl">
                             <Gavel size={80} className="text-white opacity-90" />
                        </div>
                    </div>
                </div>
            </header>

            <section className="py-20 container mx-auto px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl font-bold text-[#0f172a] mb-4">Areas of Practice</h2>
                    <div className="w-16 h-1 bg-[#0f172a] mx-auto"></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {[
                        { title: "Corporate Law", desc: "Mergers, acquisitions, and comprehensive business compliance." },
                        { title: "Constitutional Law", desc: "Deep study of rights, liberties, and government structures." },
                        { title: "Criminal Justice", desc: "Defense, prosecution, and the sociology of crime." }
                    ].map((item, i) => (
                        <div key={i} className="bg-white p-8 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                            <Book className="mb-4 text-[#0f172a]" />
                            <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                            <p className="text-gray-600 font-sans leading-relaxed">{item.desc}</p>
                            <a href="#" className="inline-block mt-4 text-[#0f172a] font-sans font-bold text-sm hover:underline">Learn more &rarr;</a>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default LegalEagle;
